import React from "react";
import styled from "styled-components";

import { color } from "style/constants";
import { StyledGrid } from "components/simple";

interface StyledCardProps {
  accentColor?: string;
}

export const StyledCard = styled(
  ({ accentColor, ...props }: StyledCardProps & any) => (
    <StyledGrid {...props} />
  )
)<StyledCardProps>`
  background: ${color.WHITE};
  border: 1px solid ${color.CARDBORDER};
  box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  ${props =>
    props.accentColor && `border-left: 5px solid ${props.accentColor};`}
`;
